"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = queryVariablesResolver;
/**
 * Resolver that captures arguments passed to queries.
 * @param _ placeholder
 * @param variables the variables
 */
function queryVariablesResolver(_, variables) {
    const { cacheKey: id, value } = variables;
    return {
        __typename: 'QueryVariables',
        id,
        value
    };
}
//# sourceMappingURL=queryVariablesResolver.js.map